






import Vue from 'vue';

import OrganizationPeerGroupSettings from '@/views/authenticated/OrganizationPeerGroupSettings.vue';
import OrganizationLoadGuard from '@/components/OrganizationLoadGuard.vue';

export default Vue.extend({
  components: {
    OrganizationPeerGroupSettings,
    OrganizationLoadGuard
  },

  props: {
    organizationId: Number,
    peerGroupId: Number
  }
});
